/**
 * Helper: Redirects
 * ------------------------------------------------------------------------------
 * An event based redirect module listening for country event changes.
 *
 * @namespace redirects
 */
import Cookies from 'js-cookie'
import {load} from '@shopify/theme-sections'

/**
 * Export new redirect helper function.
 */
export default () => {
    /**
   * Initialise component.
   */
    function init () {
        setListeners()
        handleRedirectWarning()
    }

    /**
   * Set component listeners.
   */
    function setListeners () {
        window.Frame.EventBus.listen('CountrySelector:change', (response) => onCountryChange(response))
    }

    /**
   * Handle GeoIP country code and store country code matching.
   * @param {object} response - ipstack success response.
   */
    function onCountryChange (response) {
        handleRedirects(response)
    }

    /**
   * Handle url redirect locations.
   * @param {object} response - ipstack success response.
   */
    function handleRedirects (response) {
        window.setTimeout(() => {
            window.location = getRedirectURL(response.selected)
        }, 1500)
    }

    /**
   * Get redirect URL defined in redirect modal section.
   * @param {String} location - Location country/continent code.
   */
    function getRedirectURL (location) {
        return window.Frame.Redirects.filter((element) => {
            return (element.country_code === location || element.continent_code === location)
        })[0].store_url
    }

    /**
   * Check if user is coming from a location that doesn't match the store.
   */
    function handleRedirectWarning () {
        if (isCookieSet() && Cookies.get('default_country') !== window.theme.store.countryCode) {
            load('*')
        }
    }

    /**
   * Check if cookies have been set.
   */
    function isCookieSet () {
        return typeof Cookies.get('default_country') !== 'undefined'
    }

    /**
   * Expose public interface.
   */
    return Object.freeze({
        init
    })
}



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/redirects.js